// Comparison pages served at /compare/:slug. Keep competitor descriptions fair and factual.
export const COMPARES = [
  {
    slug: "jira",
    name: "Jira",
    title: "Capittance vs Jira for ERP Programmes and PMOs",
    description: "Jira is great for software sprints. See how Capittance compares for ERP cutover, testing, RAID and executive portfolio reporting.",
    summary: "Jira is an excellent issue tracker for agile software teams. ERP programmes need cutover runbooks, go-live readiness and executive reporting on top.",
    bestFor: "Agile software teams tracking tickets and sprints.",
    rows: [
      ["Built for", "Software development and issue tracking", "ERP and transformation programmes, from plan to hypercare"],
      ["Cutover runbook", "Possible with custom workflows", "Built-in cutover tracker with owners, timings and Go/No-Go"],
      ["Test management", "Needs add-ons from the marketplace", "Built-in requirements traceability, SIT/UAT and defects"],
      ["Executive view", "Dashboards configured per team", "C-Suite portal with live RAG, RAID and board packs"],
      ["AI assistant", "Atlassian Intelligence for tickets", "NAVBOT answers programme questions from your own data"],
      ["Pricing", "Per user, plus add-ons", "Flat monthly plans from $200"],
    ],
  },
  {
    slug: "smartsheet",
    name: "Smartsheet",
    title: "Capittance vs Smartsheet for Project Portfolio Management",
    description: "Smartsheet is a flexible work-management grid. Compare it with Capittance for ERP go-lives, testing control towers and board-ready reporting.",
    summary: "Smartsheet gives teams a flexible spreadsheet-style workspace. Capittance gives ERP programmes a ready-made operating model so nothing has to be built from scratch.",
    bestFor: "Teams that want a flexible grid they configure themselves.",
    rows: [
      ["Built for", "General work management", "ERP and transformation delivery"],
      ["Set-up", "Build your own sheets and reports", "Pre-built programme, testing and cutover modules"],
      ["Go-live readiness", "Manual scorecards", "Go-live scorecard with AI risk agents"],
      ["Board reporting", "Dashboards and reports you assemble", "One-click board pack from live data"],
      ["Pricing", "Per user, tiered", "Flat monthly plans from $200"],
    ],
  },
  {
    slug: "excel",
    name: "Excel trackers",
    title: "Capittance vs Excel Trackers for ERP Cutover and Testing",
    description: "Still running your ERP cutover and testing in Excel? Compare spreadsheet trackers with a live testing and cutover control tower.",
    summary: "Excel is where every programme starts. It struggles when twelve leads update the same cutover file at 2am and executives need one trusted number.",
    bestFor: "Small pilots and one-off analysis.",
    rows: [
      ["Live updates", "Version conflicts and emailed copies", "Real-time updates for every role"],
      ["Traceability", "Manual lookups between tabs", "Requirements linked to tests and defects"],
      ["Audit trail", "Limited", "Every change logged with user and time"],
      ["Executive view", "Hand-built status slides", "Live C-Suite dashboard and exports"],
      ["Cost", "Included with Office, plus people time", "Flat monthly plans from $200"],
    ],
  },
  {
    slug: "sap-cloud-alm",
    name: "SAP Cloud ALM",
    title: "Capittance vs SAP Cloud ALM",
    description: "SAP Cloud ALM manages SAP implementations and operations. See where Capittance adds executive reporting, multi-ERP coverage and cutover command.",
    summary: "SAP Cloud ALM is SAP's own application lifecycle tool and is included for many SAP cloud customers. Capittance sits above it for executive governance and covers Oracle and Workday too.",
    bestFor: "SAP-only landscapes managing implementation tasks and operations inside the SAP toolset.",
    rows: [
      ["ERP coverage", "SAP solutions", "SAP, Oracle, Workday and Dynamics 365"],
      ["Audience", "SAP project and operations teams", "Executives, PMOs, test leads and cutover managers"],
      ["Cutover and hypercare", "Task and operations features", "Dedicated cutover tracker, hypercare incidents and go-live scorecard"],
      ["Board reporting", "Project analytics", "Board pack, PDF and PowerPoint exports"],
      ["Pricing", "Included with eligible SAP subscriptions", "Flat monthly plans from $200"],
    ],
  },
  {
    slug: "monday",
    name: "monday.com",
    title: "Capittance vs monday.com for PMOs and ERP Programmes",
    description: "monday.com is a colourful work OS. Compare it with Capittance for ERP testing, cutover, RAID and executive portfolio governance.",
    summary: "monday.com is easy to adopt for team task tracking. ERP programmes need governance depth: traceability, Go/No-Go evidence and executive roll-ups.",
    bestFor: "Cross-team task boards and lightweight workflows.",
    rows: [
      ["Built for", "General team work management", "ERP and transformation programmes"],
      ["Testing and defects", "Custom boards", "Built-in RTM, SIT, UAT and defect triage"],
      ["Cutover", "Custom boards", "Cutover tracker with Go/No-Go checkpoints"],
      ["Executive reporting", "Dashboards", "C-Suite portal, board pack and AI briefings"],
      ["Pricing", "Per seat, tiered", "Flat monthly plans from $200"],
    ],
  },
];

export const compareBySlug = (s) => COMPARES.find((c) => c.slug === s) || null;
